module.exports = __webpack_public_path__ + "static/img/a5.9243882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a5.png
// module id = EK0F
// module chunks = 0